import {atom} from 'jotai';
import {Language} from 'webapp-lib/utils';

export const languageState = atom<Language>(Language.German);
